// extracted by mini-css-extract-plugin
export default {"container":"Thanks_container__AsTXL","text":"Thanks_text__9XpM5"};